import React from "react"

import BaseSvgIcon from "../Base"

const ArrowUpDown = (props) => {
  return (
    <BaseSvgIcon {...props} width="16" height="20" viewBox="0 0 16 20" fill="none">
      <path
        d="M4 11V3.825L1.425 6.4L0 5L5 0L10 5L8.575 6.4L6 3.825V11H4ZM11 20L6 15L7.425 13.6L10 16.175V9H12V16.175L14.575 13.6L16 15L11 20Z"
        fill={props.color}
      />
    </BaseSvgIcon>
  )
}

export default ArrowUpDown
